module.exports = __webpack_public_path__ + "img/logo-simple.6e44c243.svg";